export default () => {}

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary